import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  logo: {
    maxWidth: '100%',
    height: '100%',
  },
}));

const Header = () => {
  const classes = useStyles();

  return (
    <header className='eduzz-ui-layout-topbar-header' style={{ padding: '0.75rem 2rem' }}>
      <Link to='/'>
        <img className={classes.logo} alt='MyEduzz' src='https://cdn.eduzzcdn.com/topbar/myeduzz.svg' />
      </Link>
    </header>
  );
};

export default Header;
